import { RewardType } from '@wix/ambassador-loyalty-v1-reward/types';
import { useSettings } from '@wix/tpa-settings/react';
import { Confirm as ConfirmIcon } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/yoshi-flow-editor';
import React from 'react';
import { Button, ButtonPriority, ButtonProps, ButtonSize, HoverStyles } from '@wix/wix-ui-tpa/cssVars';

import { DataHook } from '../../../types/data-hook';
import { SimpleReward } from '../../../types/domain';
import settingsParams from '../settingsParams';
import { classes } from './list-item-button.st.css';
import { RewardProgress } from './reward-progress';

interface ListItemProps {
  onClick(): void;
  reward: SimpleReward;
  showCopied?: boolean;
  hasEnoughPoints: boolean;
}

export const ListItemButton: React.FC<ListItemProps> = ({ onClick, reward, showCopied, hasEnoughPoints }) => {
  const settings = useSettings();
  const { t } = useTranslation();
  const isCouponReward = reward.type === RewardType.COUPON_REWARD;
  const isRedeemedCouponReward = reward.couponActivated;

  const handleClick: ButtonProps['onClick'] = (event) => {
    event.preventDefault();
    onClick();
  };

  const commonButtonProps = {
    size: ButtonSize.small,
    upgrade: true,
    onClick: handleClick,
  };

  if (isCouponReward) {
    if (isRedeemedCouponReward) {
      return (
        <Button
          {...commonButtonProps}
          priority={ButtonPriority.secondary}
          data-hook={DataHook.RewardsListItemButtonCouponCopy}
          hoverStyle={showCopied ? HoverStyles.colorChange : HoverStyles.underline}
          className={classes.secondaryButton}
        >
          <span className={showCopied ? classes.container : ''}>
            {showCopied && (
              <ConfirmIcon
                size="24px"
                className={classes.confirmIcon}
                role="status"
                aria-label={t('app.coupon-code-copied')}
              />
            )}
            <span className={showCopied ? classes.buttonText : ''}>{settings.get(settingsParams.copyButton)}</span>
          </span>
        </Button>
      );
    } else if (hasEnoughPoints) {
      return (
        <Button
          {...commonButtonProps}
          data-hook={DataHook.RewardsListItemButtonCouponGet}
          hoverStyle={HoverStyles.underline}
          className={classes.primaryButton}
        >
          {settings.get(settingsParams.getButton)}
        </Button>
      );
    }
  }

  return <RewardProgress reward={reward} />;
};
